import { useEffect } from 'react';

import { Footer } from '@/v2/components/Footer';
import GlassGridBackground from '@/v2/components/GlassGridBackground';
import { NavBar } from '@/v2/components/NavBar';

import { FeaturesSection } from './FeaturesSection';
import { HeroSection } from './HeroSection';
import { InstallSection } from './InstallSection';
import { SPECModeSection } from './SPECModeSection';
import css from './index.module.less';

export function CliPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className={css['cli-page']}>
      <NavBar />
      <div className="">
        <div className="relative min-h-[306px] px-[28px] py-[40px] sm:px-6 sm:py-[54px] md:px-[calc(min(108px,8vw))] md:py-[64px] lg:px-[max(88px,8vw)] lg:py-[88px]">
          {/* 毛玻璃格子背景 */}
          <GlassGridBackground />
          <div className="space-between z-1000 relative flex flex-col gap-[40px] lg:flex-row lg:items-center lg:gap-[109px]">
            <div className="w-full flex-1">
              <HeroSection />
            </div>
            <div className="w-full rounded-[8px] border-4 border-solid border-[rgba(255,255,255,0.60)]  lg:w-1/2">
              <InstallSection />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[40px] px-[28px] py-[40px] md:px-[calc(min(88px,8vw))] md:py-[64px] lg:px-[max(88px,8vw)] lg:py-[88px]">
          <SPECModeSection />
          <FeaturesSection />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CliPage;
